// extracted by mini-css-extract-plugin
export default {"name__cell":"ToolRow_name__cell__7JFzA","text--bold":"ToolRow_text--bold__3Llsw font-sm-bold"};